module.exports = __webpack_public_path__ + "static/media/Portrait-10181.b7ab883b.jpg";